import { Button } from '@/components/Button';
import { Form } from '@/components/Form';
import { Flex } from '@/components/Grid';
import { Heading } from '@/components/Heading';
import { Input } from '@/components/Input';
import { Section } from '@/components/Section';
import { Text } from '@/components/Text';
import { forgotPassword, useAccount } from '@/resource/account';
import { routeToPath } from '@/util/routeToPath';
import { staticProps } from '@/util/staticProps';
import { NextSeo } from 'next-seo';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useBoolean } from 'usehooks-ts';
import z from 'zod';

const schema = z.string().email();
const title = 'Wachtwoord vergeten';

export default function ForgotPassword() {
  const { push } = useRouter();
  const { profile } = useAccount();
  const hasProfile = profile != null;
  const [email, setEmail] = useState('');
  const sent = useBoolean(false);

  useEffect(() => {
    if (hasProfile) {
      push(routeToPath({ type: 'account' }));
    }
  }, [push, hasProfile]);

  return (
    <>
      <NextSeo title={title} />
      <Section>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            forgotPassword({ email })
              .then(() => sent.setTrue())
              .catch((err) => console.log(err));
          }}
        >
          <Flex dir="column" gap={3}>
            <Heading align="center">{title}</Heading>

            {sent.value ? (
              <Text align="center">
                Er is een e-mail gestuurd naar {email}.
              </Text>
            ) : (
              <>
                <Input
                  autoComplete="nope"
                  label="E-mailadres"
                  type="email"
                  id="email"
                  value={email}
                  required
                  onChange={(e) => setEmail(e.target.value)}
                />

                <Button
                  align="center"
                  disabled={!schema.safeParse(email).success}
                  type="submit"
                  icon="mail"
                >
                  Stuur e-mail
                </Button>
              </>
            )}
          </Flex>
        </Form>
      </Section>
    </>
  );
}

export const getStaticProps = staticProps.resolve(async () => {
  return {
    props: {},
    revalidate: 10,
  };
});
